import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popover } from 'antd';
import moment from 'moment';
import { getActiveIcon } from 'library/helpers';
import { isOptimiserActive } from 'library/optimiser';

export const MAX_TOOLTIP_VIOLATIONS = 20;

const InactiveAccountIcon = (
  <Icon type="minus-circle" style={{ color: '#8c8c8c', fontSize: '14px' }} />
);

const OptedOutIcon = (
  <Icon type="minus-circle" style={{ color: '#8c8c8c', fontSize: '14px' }} />
);

const WarningIcon = (
  <Icon type="exclamation-circle" style={{ color: '#faad14', fontSize: '14px' }} />
);

const ReadinessHover = ({
  children, ready, violations, optedOut, warning, warningDetails, inactive
}) => {
  let content;
  if (inactive) {
    content = <div>Account inactive</div>;
  }
  else if (optedOut) {
    content = <div>Not included for the Optimiser</div>;
  }
  else if (!ready && violations && violations.length > 0) {
    const shown = violations.slice(0, MAX_TOOLTIP_VIOLATIONS);
    content = (
      <div>
        <div>Not Optimiser ready:</div>
        <ul>
          {shown.map(v => (
            <li key={`${v.error_type}-${v.detail}`}>{`${v.error_type}: ${v.detail}`}</li>
          ))}
        </ul>
        {violations.length > MAX_TOOLTIP_VIOLATIONS && (
          <div>{`+${violations.length - MAX_TOOLTIP_VIOLATIONS} more`}</div>
        )}
      </div>
    );
  }
  else if (!ready) {
    content = <div>Not Optimiser ready</div>;
  }
  else if (warning) {
    content = (
      <div>
        <div>Optimiser ready - tag expiring soon:</div>
        <ul>
          {(warningDetails || []).map(d => (
            <li key={`${d.collection}-${d.tag_value}`}>
              {`${d.collection}: ${d.tag_value} expires ${moment(d.expiry_date).format('DD MMM YYYY HH:mm')}`}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  else {
    content = <div>Optimiser ready</div>;
  }
  return <Popover content={content}>{children}</Popover>;
};

ReadinessHover.propTypes = {
  children: PropTypes.any.isRequired,
  ready: PropTypes.bool.isRequired,
  violations: PropTypes.array,
  optedOut: PropTypes.bool,
  warning: PropTypes.bool,
  warningDetails: PropTypes.array,
  inactive: PropTypes.bool
};

ReadinessHover.defaultProps = {
  violations: [],
  optedOut: false,
  warning: false,
  warningDetails: [],
  inactive: false
};

export const buildReadinessColumn = () => ({
  title: 'Optimiser readiness',
  dataIndex: 'optimiser_ready',
  width: '160px',
  align: 'center',
  sorter: true,
  render: (text, record) => {
    const {
      is_active: isActive,
      is_tenancy_active: isTenancyActive,
      optimiser_opted_out: optedOut,
      optimiser_ready: ready,
      optimiser_violations: violations,
      optimiser_warning: warning,
      optimiser_warning_details: warningDetails
    } = record;
    const isInactive = isActive === false || isTenancyActive === false;
    let icon;
    if (isInactive) {
      icon = InactiveAccountIcon;
    }
    else if (optedOut) {
      icon = OptedOutIcon;
    }
    else if (!ready) {
      icon = getActiveIcon(ready);
    }
    else if (warning) {
      icon = WarningIcon;
    }
    else {
      icon = getActiveIcon(ready);
    }
    return (
      <ReadinessHover
        ready={!!ready}
        violations={violations || []}
        optedOut={!!optedOut}
        warning={!!warning}
        warningDetails={warningDetails || []}
        inactive={isInactive}
      >
        {icon}
      </ReadinessHover>
    );
  }
});

export { isOptimiserActive };
